import type { AxiosInstance } from 'axios'

import { COMPANY_STATUS_TRANSITION_TYPE } from '../../constants/enums/company.enum.constant'

export const updateCompanyStatus = (api: AxiosInstance) => (
  companyId: string,
  action: keyof typeof COMPANY_STATUS_TRANSITION_TYPE
) => api.post(`/v1.0/admin/companies/${companyId}/status/${action}`)
